import React, { useState } from "react";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SaveIcon from "@material-ui/icons/Save";
import AddNewItem from "../../../../../../components/modals/AddNewItem";
import AssignmentForm from "../components/AssignmentForm";
import AssignmentService from "../../../../../../../services/AssignmentService";
import { showSnackBar } from "../../../../../../../redux/actions/ui";

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function AddAssignment(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { courseId, lessonId } = props;

  const { register, errors, handleSubmit, control } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });

  const createAssignment = async data => {    
    setIsLoadingSubmit(true);     
    setIsEditableForm(false);    
    try{
      data.start_date = data.end_date;
      await AssignmentService.createAssignment(courseId, lessonId, data);
      setIsLoadingSubmit(false);      
      setIsEditableForm(true);
      dispatch(showSnackBar("Successfully edited!"));      
      // We updated the list
      props.updateAssignmentsFromList();
      props.onClose(false);      
    }catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
      setIsEditableForm(true);
    }  
  };

  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}           
          onClick={handleSubmit(createAssignment)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Save
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} title="New Assignment">
      <AssignmentForm isEditableForm={isEditableForm} onSubmit={createAssignment} formConfig={ {register, errors, handleSubmit, control} }/>
    </AddNewItem>
  )
}

export default AddAssignment;